import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52834564&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52834564&prod&lang=sass&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=52834564&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52834564",
  null
  
)

export default component.exports